import api from "./api";
import config from "../config";

export default {
  async getReminders() {
    return await api.get(`${config.url.api}/v1/settings/0/reminder`);
  }
};
